var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BC49F4D4-6199-402F-BE56-8FC5C70407E4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-696.000000, -3215.000000)",
    fill: "#007CFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(127.000000, 3160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/send",
    transform: "translate(569.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.86275,4.13734375 C19.7301563,4.00471875 19.5312188,3.9639375 19.3572188,4.0335625 L4.2946875,10.0585 C4.12234375,10.1274375 4.0069375,10.2915625 4.0003125,10.4770937 C3.99371875,10.6625937 4.09721875,10.8345 4.26421875,10.9155 L10.2038438,13.7961562 L13.0845313,19.7357812 C13.1630938,19.8977812 13.3271563,20 13.5061875,20 C13.51175,20 13.5173438,20 13.5229375,19.9996875 C13.7084063,19.9930937 13.8725938,19.8776875 13.9415,19.7053438 L19.9665,4.64290625 C20.036125,4.46878125 19.9953438,4.2699375 19.86275,4.13734375 Z M5.6279375,10.5349375 L17.585,5.75215625 L10.4590938,12.878 L5.6279375,10.5349375 Z M13.4650938,18.3720937 L11.122,13.540875 L18.2479375,6.41503125 L13.4650938,18.3720937 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e6fe26f4.svg";
export { ForwardRef as ReactComponent };